import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnAuthor001 from '../../../components/molecules/columnAuthor001'
import ColumnDetailInner0024 from '../../../components/molecules/columnDetailInner0024'
import ColumnRelationCards0024 from '../../../components/molecules/columnRelationCards0024'
import UsefulFunctionLayout024 from '../../../components/molecules/usefulFunctionLayout024'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import PopupBanner from '../../../components/molecules/popupBanner'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0024 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: '時間有給と半休について、基本知識を解説します！',
    },
  ]
  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="時間単位と半日単位の有給休暇とは？制度内容と導入方法を解説"
        description="時間単位の有給休暇は、法律上は5日以内に付与することができます。制度化するには労使協定の締結が必要となります。このページでは基礎知識を解説します。"
        ogUrl="https://kintaicloud.jp/column/details/C0024/"
        ogType="article"
        ogTitle="時間単位と半日単位の有給休暇とは？制度内容と導入方法を解説"
        ogDescription="時間単位の有給休暇は、法律上は5日以内に付与することができます。制度化するには労使協定の締結が必要となります。このページでは基礎知識を解説します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0024.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0024 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor001 />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** お役立ち機能 */}
        <UsefulFunctionLayout024 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        <ColumnRelationCards0024 />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0024

export const pageQuery = graphql`
  query C0024 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
